import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import style from "./index.module.scss";
import { CourseContext } from "../../../../Store";
import { isTrue } from "Utils/filter";
import { customerCode, getActivityByWeekTimeId } from "API";
import Config from "config";
import { makeCourseParams } from "API/urls";
import useRequest from "../../../../../../Utils/useRequest";
import useBatchPicker from "../../../../../main/utils/useBatchPicker";
import { hasPartInAllActivity } from "../../../../../../API/teams";
import NavItem from "./Components/NavItem";

export default function NavBar() {
    const history = useHistory();

    const { course, basename } = useContext(CourseContext);
    const { courseNo, courseSeq, isCloud } = course;

    const { batch } = useBatchPicker();

    const [haveTeamDot] = useRequest(
        async () =>
            hasPartInAllActivity({
                batchNo: batch,
                courseNo,
                courseSeq,
                weektimeId: course.weekTimeId
            }),
        {},
        [course.weekTimeId, batch, courseNo, courseSeq]
    );

    const [activity] = useRequest(
        () =>
            getActivityByWeekTimeId(
                course.weekTimeId,
                course.courseNo,
                course.courseSeq,
                course.courseId
            ),
        {},
        [course.weekTimeId, batch, courseNo, courseSeq]
    );

    function isMatch(path: string) {
        return history.location.pathname.indexOf(path) !== -1;
    }

    const lmsUrl = () => {
        const userId = localStorage.getItem("user");
        return `${Config.ApiHost}student/redirectKczy?userId=${userId}&courseId=${course.lmsCourseNo}&customerCode=${customerCode}`;
    };

    const homeworkUrl = () => {
        const {
            courseSeq,
            courseNo,
            section,
            continunity,
            weekNo: weekTime,
            dayOfWeek: week
        } = course;
        return `homework/${makeCourseParams({
            courseSeq,
            courseNo,
            section,
            continunity,
            week,
            weekTime
        })}`;
    };

    return (
        <div className={style.root}>
            <div className={style.links}>
                <NavItem
                    src={`${basename}/courseware`}
                    text="课件"
                    notice={isTrue(activity?.coursewareLearnStatus)}
                />
                <NavItem
                    src={`${basename}/signin`}
                    text="签到"
                    notice={isTrue(activity?.signStatus)}
                />
                <NavItem
                    src={`${basename}/vote`}
                    text="投票"
                    notice={isTrue(activity?.votePaperStatus)}
                />
                <NavItem
                    src={`${basename}/exercise`}
                    text="练习"
                    notice={isTrue(activity?.exerciseStatus)}
                />
                <NavItem src={homeworkUrl()} text="作业" />
                <NavItem src={`${basename}/experiment`} text="实验" />
                <NavItem
                    src={`${basename}/teams`}
                    text="小组"
                    notice={haveTeamDot === "0"}
                />
                <NavItem src={`${basename}/meeting`} text="会议活动" />
                <NavItem
                    src={`${basename}/question`}
                    text="问卷"
                    notice={isTrue(activity?.questionnaireStatus)}
                />
                <NavItem src={`${basename}/discuss`} text="主题讨论" />
            </div>
        </div>
    );
}
